import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AppsRoutes } from './pages/apps/apps.routes';
import {PermissionGuard} from "./guards/permission.guard";
import { MediaViewerComponent } from './components/media-viewer/media-viewer.component';
import {NavLessComponent} from "./layouts/navLess/navLess.component";
import {AppChatComponent} from "./pages/apps/chat/chat.component";

export const routes: Routes = [
  {
    path: 'chat',
    component: NavLessComponent,
    children: [
      {
        path: '',
        component: AppChatComponent,
      },
      {
        path: ':sessionId',
        component: AppChatComponent,
      },
    ],
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',

        redirectTo: '/authentication/side-register',
        pathMatch: 'full',
      },
      {
        path: 'starter',
        loadChildren: () =>
          import('./pages/pages.routes').then((m) => m.PagesRoutes),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboards/dashboards.routes').then(
            (m) => m.DashboardsRoutes
          ),
      },

      {
        path: 'forms',
        loadChildren: () =>
          import('./pages/forms/forms.routes').then((m) => m.FormsRoutes),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./pages/charts/charts.routes').then((m) => m.ChartsRoutes),
      },
      {
        path: 'apps',
        loadChildren: () => AppsRoutes,
        canActivateChild: [PermissionGuard]
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./pages/widgets/widgets.routes').then((m) => m.WidgetsRoutes),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./pages/tables/tables.routes').then((m) => m.TablesRoutes),
      },
      {
        path: 'datatable',
        loadChildren: () =>
          import('./pages/datatable/datatable.routes').then(
            (m) => m.DatatablesRoutes
          ),
      },
      {
        path: 'theme-pages',
        loadChildren: () =>
          import('./pages/theme-pages/theme-pages.routes').then(
            (m) => m.ThemePagesRoutes
          ),
      },
      {
        path: 'ui-components',
        loadChildren: () =>
          import('./pages/ui-components/ui-components.routes').then(
            (m) => m.UiComponentsRoutes
          ),
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
      {
        path: 'landingpage',
        loadChildren: () =>
          import('./pages/theme-pages/landingpage/landingpage.routes').then(
            (m) => m.LandingPageRoutes
          ),
      },
      {
        path: 'media-viewer',
        component: MediaViewerComponent,
        data: {
          title: 'Media Viewer'
        }
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];
